<template>
  <div id="app">
    <router-view />
    <!-- 竖屏提醒 -->
    <div class="page-landscape" id="page-landscape" v-if="isPortrait">
      <div class="page-landscape-box">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAAB4CAMAAADVLa6HAAABCFBMVEUAAAAAAAAAAABWVlYAAADFxcUAAACKioovLy8AAAAAAAAAAAC+vr6+vr6EhIQAAAALCwsBAQEGBgbIyMjGxsYAAADGxsbHx8cAAADHx8fAwMCoqKi9vb1SUlIGBgbHx8fFxcW0tLSxsbGgoKC7u7slJSVeXl6ysrLFxcW/v7+7u7uoqKiRkZEUFBQFBQWMjIxxcXHExMTExMTCwsK6urq2trbBwcHExMSsrKzExMS1tbWUlJTDw8O0tLSnp6dpaWm9vb1ZWVmDg4PAwMCvr6+Ojo4+Pj4xMTFKSkpnZ2e2trahoaGxsbGfn5+3t7ecnJyvr6+CgoKVlZU9PT1WVlasrKy8vLzJycmXdzvDAAAAV3RSTlMAARMjBL8WfEggDinGSGgeBwsj++IU8vkb9N6oeE0x7tBMt49nLykPxtLEmoM9NxcG6dvl0Ma6sLCnnYmHb11cW1hSUUFAOzo2NCQcqpmOfXx1bUY9Ny21pUe+AAAC6klEQVR42uzaV2/bMBSGYVI9kRs6aanhWc/YiffKHs1oM5t0r+///5MyrgvXqR0XuZIP+N5IF7rQAxIHAkQxTpJWDo+URySmRPri48oghcUvKDbef/UT3j9Mqaub4FSydePqSSb9KAGZtU9v3208W/g2Lk8OQ8Ns+4r+NlZTSFbWXaWJSC58BuGdlIC1dYfGxhywc+V6JPhEOhdgZ6yUZ8CruMOJOGSWM1iLqxHrNmOMiptRCFkOcOTr3/e72C6wW8ehLIfkN3cou0DqTZqjUYh+yexRT5j2sB/3pGDZKjKdBAlRC8B1IYWQm4gtG9w5sgVn2kKS5yxAcwbmazNgvfvLvrlMaQmL0JWSj+/XbEEJcYCKrxcX+dx9FHmLVNcRYhftWcj2ddS/ZOcia0AnIY0ltjwDGfO1jHZzkcI8MULSDORy1KfufyFdi7TISGSRFmmR0coiLdIio9UTkMMfPh5Jzkiqhkg1vyeIM/IcK63DTCOuJGPkXlhIe8c4dYkxcmklrsQqXry0yEhlkRZpkdHKIi3SIqOVRVqkRUYri+SJJK2U4zhKE1sk9Y6bYRAMmpUb1yOeyH6uiFGp1rpDkh9S3tWBbMWc17383DB3eVdLdsi7EMmY72gy6XKIYt4lbsh+HVv59J+BI3slZK8TxAyZQzKfpvGc7YX3JwclK2StiCPfmMaVEeRdYoU8w1Y3MfGuVMcHX7NCHgyPtU5UxXZBsULW8eXhq/7EoOuwQoY4fXhkt4agwwv5q707OGEYiKEg2kUgpyQtpBn334nB+OgChN78DgYWe1eg+Z8nyGMZ5PfpuL6WHVfiw0P8QojLAHGtMy7oxFPLeDQT4497kPV/7x5kGSNJZLgcZJCjE2SQQc5KkEEGOStButsExF4IseFD7GoZW3dBjkyQQQY5K0EGGeSsBClCrle6EXI+QrNICDMJ9SkhsV2tI/5dOmJFLE0owgnZu6HtJwoYjCoNoxTFqLcxiop2V06dXT9t25ovKx4AAAAASUVORK5CYII="
          id="page-landscape-pic"
          style="display: inline-block"
          width="114"
          height="60"
        />
        <span v-if="supporter === 'micromessenger'"
          >为了更好的体验，请您打开手机旋转及微信横屏开关，横屏浏览</span
        >
        <span v-else-if="supporter === 'qq'"
          >不支持QQ打开浏览，请使用微信，Chrome，Edge，Safari浏览器打开</span
        >
        <span v-else>为了更好的体验，请您打开手机旋转开关，横屏浏览</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isPortrait:false,
        supporter: "",
    };
  },

  components: {},
  methods: {
    mobileCheck() {
      let check = 0;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          // eslint-disable-next-line no-useless-escape
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = 1;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    renderResize() {
      // 判断横竖屏
      let width = window.innerWidth;
      let height = window.innerHeight;
      if (width > height) {
        this.isPortrait = false;
      } else {
        this.isPortrait = true;
      }
    },
    checkUA() {
      const ua = navigator.userAgent.toLowerCase();
      const testUa = (regexp) => regexp.test(ua);
      // 接上以上if...else条件判断
      // 获取到system、systemVs、platform、engine、engineVs、supporter、supporterVs、shell、shellVs
      if (testUa(/applewebkit/g)) {
        if (testUa(/micromessenger/g)) {
          this.supporter = "micromessenger";
        } else if (testUa(/ucbrowser/g)) {
          this.supporter = "ucbrowser";
        } else if (testUa(/vivobrowser/g)) {
          this.supporter = "vivobrowser";
        } else if (testUa(/quark/g)) {
          this.supporter = "quark";
        } else if (testUa(/miuibrowser/g)) {
          this.supporter = "miuibrowser";
        } else if (testUa(/sougou/g)) {
          this.supporter = "sougou";
        } else if (testUa(/baidu/g)) {
          this.supporter = "baidu";
        } else if (testUa(/ucbrowser/g)) {
          this.supporter = "ucbrowser";
        } else if (testUa(/qq/g)) {
          this.supporter = "qq"; // qq
        } else if (testUa(/opr/g)) {
          this.supporter = "opera"; // opera浏览器
        } else if (testUa(/safari/g)) {
          this.supporter = "safari"; // safari浏览器
        } else if (testUa(/edge/g)) {
          this.supporter = "edge"; // edge浏览器
        } else if (testUa(/chrome/g)) {
          this.supporter = "chrome"; // chrome浏览器
        }
      } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
        this.supporter = "firefox"; // firefox浏览器
      } else if (testUa(/presto/g)) {
        this.supporter = "opera"; // opera浏览器
      } else if (testUa(/trident|compatible|msie/g)) {
        this.supporter = "iexplore"; // iexplore浏览器
      }
    }
  },
  created() {
    sessionStorage.setItem("isMobile", this.mobileCheck());
    this.checkUA();
  },
  mounted() {
    // 监听 resize 方法
    if (window.orientation === 0 || window.orientation === 180) {
      this.isPortrait = true;
    } else if (window.orientation === 90 || window.orientation === -90) {
      this.isPortrait = false;
    }

    window.addEventListener("resize", this.renderResize, false);
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("resize", this.renderResize, false);
  },
};
</script>

<style>
html,
body,
.el-container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  background-color: #2c2c2e;
}
.page-landscape {
  width: 100vw;
  height: 100vh;
  background: #333;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 3;
  text-align: center;
  z-index: 99999;
}
.page-landscape-box {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 50%;
  transform: translateY(-50%);
}
.page-landscape-box img {
  display: inline-block;
  animation: page-landscapeAni 1.2s ease infinite alternate;
}
/* prettier-ignore */
.page-landscape span {
  font-size: 22PX;
  display: block;
  color: #ffffff;
  text-align: center;
  width: 100%;
  padding-top: 150PX;
  line-height: 2;
}

@keyframes page-landscapeAni {
  0% {
    transform: rotate(90deg);
  }
  30% {
    transform: rotate(90deg);
  }
  70% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
